import type { OverlayStatus } from '@/api/medicalOverlay.api';

export interface OverlayStatusStyle {
  label: string;
  symbol: string;
  /** Rahmenfarbe des Knotens */
  ring: string;
  /** Badge-Hintergrund / -Vordergrund (Statuspunkt oben rechts) */
  badgeBg: string;
  badgeFg: string;
  /** Schraffur statt Vollfläche – macht „unbekannt" visuell klar ≠ „kein Risiko". */
  hatched?: boolean;
}

export const OVERLAY_STATUS_STYLE: Record<OverlayStatus, OverlayStatusStyle> = {
  affected: { label: 'betroffen', symbol: '●', ring: '#dc2626', badgeBg: '#dc2626', badgeFg: '#ffffff' },
  obligate_carrier: { label: 'obligate:r Träger:in', symbol: '◼', ring: '#7c3aed', badgeBg: '#7c3aed', badgeFg: '#ffffff' },
  at_risk: { label: 'Risiko (berechnet)', symbol: '◐', ring: '#f59e0b', badgeBg: '#f59e0b', badgeFg: '#ffffff' },
  unaffected_observed: { label: 'nicht betroffen', symbol: '○', ring: '#cbd5e1', badgeBg: '#ffffff', badgeFg: '#64748b' },
  unknown: { label: 'unbekannt', symbol: '?', ring: '#cbd5e1', badgeBg: '#e2e8f0', badgeFg: '#64748b', hatched: true },
  inconsistent: { label: 'Widerspruch / de novo', symbol: '⚠', ring: '#b91c1c', badgeBg: '#fef08a', badgeFg: '#92400e' },
};

// Reihenfolge für Legenden
export const OVERLAY_STATUS_ORDER: OverlayStatus[] = [
  'affected',
  'obligate_carrier',
  'at_risk',
  'unaffected_observed',
  'inconsistent',
  'unknown',
];
